import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NavbarSeller from './NavbarSeller';
import Navbar from '../web-pages/Navbar';
import SideNav from './SideNav';
function Header(props) {
 const [mobileOpen, setMobileOpen] = useState(false);


    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    return (
        <div className='navigation'>
            <NavbarSeller handleDrawerToggle={handleDrawerToggle} />
            <Navbar />
            <SideNav mobileOpen={mobileOpen} handleDrawerToggle={() => handleDrawerToggle()} />

        </div>



    );
}

export default Header;
